import OurFeesCompensationTable from "modules/storyblok/components/OurFeesCompensationTable";
import type { ReactStoryblokComponent } from "modules/storyblok/types";
import type { OurFeesCompensationTableAdapterProps } from "./OurFeesCompensationTable.d";

const OurFeesCompensationTableAdapter = ({ blok }: ReactStoryblokComponent<OurFeesCompensationTableAdapterProps>) => (
   <OurFeesCompensationTable blok={blok} />
);

export default OurFeesCompensationTableAdapter;
